import { render } from "./WinnerScreen.vue?vue&type=template&id=663b6030&scoped=true&lang=html"
import script from "./WinnerScreen.vue?vue&type=script&lang=js"
export * from "./WinnerScreen.vue?vue&type=script&lang=js"

import "./WinnerScreen.vue?vue&type=style&index=0&id=663b6030&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/aethonspel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663b6030"]])

export default __exports__